import { OrderedMap, OrderedSet } from "immutable"
import * as React from "react"


interface RoomFilterProps {
  readonly enabled: boolean

  readonly eventTypes: OrderedSet<string>

  readonly selectedEventType: string
  readonly selectedCapacity: string
  readonly selectEventType: (e: string) => void
  readonly selectCapacity: (e: string) => void
}

interface RoomFilterState { }

const roomFilterStateZero: RoomFilterState = {}

export interface CapacityOption {
  min: number
  max: number
  label: string
}

export const capacityOptions: OrderedMap<string, CapacityOption> = OrderedMap<string, CapacityOption>([
  ['a', {min: 0, max: 10, label: "Minder dan 10"}],
  ['b', {min: 10, max: 50, label: "Tussen 10 en 50"}],
  ['c', {min: 50, max: Number.MAX_SAFE_INTEGER, label: "Meer dan 50"}]
])

export class RoomFilter extends React.Component<RoomFilterProps, RoomFilterState> {
  constructor(props: RoomFilterProps) {
    super(props)

    this.state = roomFilterStateZero
  }

  render() {
    const eventTypeFilter: JSX.Element = (
      <div className="o-filter__field form__select form__item--icon left">
        <select
          onChange={e => this.props.selectEventType(e.target.value)}
          disabled={!this.props.enabled}
          value={this.props.selectedEventType}
          id="zvf-type"
        >
          <option key={"event-type-all"} value="">Kies een opstelling</option>
          {this.props.eventTypes.map((title) => <option key={title} value={title}>{title}</option>)}
        </select>
        <svg className="form__icon" width="23px" height="22px" aria-hidden="true">
          <use xlinkHref="#icon--type" />
        </svg>
      </div>
    )

    const capacityFilter: JSX.Element = (
      <div className="o-filter__field form__select form__item--icon left">
        <select
          onChange={e => this.props.selectCapacity(e.target.value)}
          value={this.props.selectedCapacity}
          disabled={!this.props.enabled}
          id="zvf-capacity"
        >
          <option key={"event-type-all"} value="">Kies een capaciteit</option>
          {capacityOptions.map((option, key) => <option key={key} value={key}>{option.label}</option>).toArray()}
        </select>
        <svg className="form__icon" width="24px" height="20px" aria-hidden="true">
          <use xlinkHref="#icon--capacity" />
        </svg>
      </div>
    )

    return (
      <fieldset className="o-filter zv-filter">
        <legend className="sr-text">Filter zalen op evenement types en capaciteit</legend>
        <div className="o-filter__inner zv-filter__inner">
          <div className="o-filter__item">
            <label className="sr-text" htmlFor="zvf-type">Evenement type</label>
            {eventTypeFilter}
          </div>
          <div className="o-filter__item ">
            <label className="sr-text" htmlFor="zvf-capacity">Capaciteit</label>
            {capacityFilter}
          </div>
        </div>
      </fieldset>
    )
  }
}

{/* TH: Added to styleguide! */ }
